import { PolicySelectorWebComponentSchema } from '../types/PolicySelectorWebComponentSchema';
import { PoliciesSelectorBaseDataProvider } from './PoliciesSelectorBaseDataProvider';
import { sanitizeObject } from '../../utils/sanitization.utils';
import { EditableModuleAndSection, RpcAction, RpcPolicyTemplatesMethod } from '../types';
import { ConsoleRequest, DataProviderType } from '../../utils/request';

export class PoliciesSelectorNirvanaDataProvider extends PoliciesSelectorBaseDataProvider {

  async getPolicies(editableModuleAndSection: EditableModuleAndSection): Promise<PolicySelectorWebComponentSchema | undefined> {
    const request = {
      companyId: this.dependencies.getActiveCompany().companyId,
      editableModuleAndSection: editableModuleAndSection
    };
    try {
      const response = await this.getEditablePoliciesByCompany(request.companyId, request.editableModuleAndSection);
      response['data'] = response.data.map(function (policy) {
        return {
          value: policy._id,
          label: policy.name,
          inheritsFrom: policy.inheritsFrom ?? null,
          isEditable: typeof policy.isEditable === 'boolean' ? policy.isEditable : true,
        };
      });
      return sanitizeObject(response);
    } catch (e) {
      throw new Error(e);
    }
  }

  public async getEditablePoliciesByCompany(companyId, editableModuleAndSection): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        companyId: companyId,
        editableModuleAndSection: editableModuleAndSection,
      },
      endpoint: RpcAction.POLICY_TEMPLATES,
      method: RpcPolicyTemplatesMethod.GET_POLICIES_BY_COMPANY,
    });
  }

}
